export class Card {
  constructor(public buttonLink: string, public size: string, public price: number, public imgPath: string){}
}
